import {
  Typography,
  Form,
  Input,
  InputNumber,
  Select,
  Button,
  Space,
  DatePicker,
  Col,
  Row,
} from 'antd';

import { useAuth } from '../../hooks/useAuth';
import React, { useState, useEffect } from 'react';
import SecurityService from '../../services/SecurityService';
import ShareSplittingService from '../../services/ShareSplittingService';
const { Title, Text } = Typography;

const ShareSplitting = () => {
  const [form] = Form.useForm();
  const { showNotification } = useAuth();
  const [requiredMark, setRequiredMarkType] = useState('');
  const [securities, setSecurities] = useState([]);
  const [loading, setLoading] = useState(false);

  const onFinish = async formValues => {
    const payload = {
      securityCode: formValues.securityCode,
      symbolCode: formValues.symbolCode,
      tradeWindow: formValues.tradeWindow.format('YYYYMMDD'),
      settlementWindow: formValues.settlementWindow.format('YYYYMMDD'),
      caCode: formValues.caCode || '',
      corporateActionType: formValues.caType,
      isinCode: formValues.isinCode,
      productType: formValues.productType || '',
      note: formValues.note || '',
      rightAllotmentDate: null,
      effectiveDate: null,
      ratioFrom: formValues.ratioFrom,
      ratioTo: formValues.ratioTo,
    };
    setLoading(true);
    const result = await ShareSplittingService.performSplit(payload);
    setLoading(false);
    console.log(result);

    if (result.success) {
      showNotification('success', 'Splitted');
    } else {
      showNotification('error', result.message);
    }
  };

  const symbolCode = securities.map(item => item.symbolCode).sort();

  const onRequiredTypeChange = ({ symbolCode }) => {
    // setRequiredMarkType(requiredMarkValue);
    if (symbolCode) {
      let security = securities.find(security => security.symbolCode === symbolCode);
      form.setFieldsValue({
        securityName: security.securityName,
        securityCode: security.securityCode,
        isinCode: security.isinCode,
        // securityCode: security.securityCode,
      });
    }
  };

  useEffect(() => {
    const getSecurities = async () => {
      setLoading(true);
      let response = await SecurityService.getSecurities();
      setLoading(false);
      console.log(response);
      if (response.success) setSecurities(response.securityDataList);
      else showNotification('error', response.message);
    };
    getSecurities();
  }, []);

  return (
    <>
      <Title level={4} style={{ marginTop: 0, marginBottom: '2rem' }}>
        Share Splitting
      </Title>
      <Form
        className="block-trade-form"
        onFinish={onFinish}
        form={form}
        labelCol={{
          span: 12,
        }}
        style={{
          padding: '2rem 0',
        }}
        onValuesChange={onRequiredTypeChange}
        requiredMark={requiredMark}
      >
        {/* <Form.Item label="Trading Account Id" name={'tradingAccountId'}>
          <Input disabled />
        </Form.Item> */}
        <Row gutter={16}>
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              label="Symbol Code"
              name={'symbolCode'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Select size="middle">
                {symbolCode.map((item, index) => (
                  <Select.Option key={index} value={item}>
                    {item}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Security Code"
              name={'securityCode'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Input defaultValue={''} size="middle" disabled />
            </Form.Item>
            <Form.Item
              label="ISIN Code"
              name={'isinCode'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Input defaultValue={''} size="middle" disabled />
            </Form.Item>
            <Form.Item label="CA Code" name={'caCode'}>
              <Input />
            </Form.Item>
            <Form.Item
              label="CA Type"
              name={'caType'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <Select size="middle">
                <Select.Option value={'STOCK_SPLIT'}>Stock Split</Select.Option>
                <Select.Option value={'REVERSE_STOCK_SPLIT'}>Reverse Stock Split</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item label="Product Type" name={'productType'}>
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item label="Note" name={'note'}>
              <Input />
            </Form.Item>
            <Form.Item
              label={'Ratio From'}
              name={'ratioFrom'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <InputNumber
                className="number-input"
                min={1}
                formatter={value => Number(value).toLocaleString('en-US')}
                parser={value => Number(value.toString().split(',').join(''))}
              />
            </Form.Item>
            <Form.Item
              label={'Ratio To'}
              name={'ratioTo'}
              rules={[
                {
                  required: true,
                  message: 'Please do not leave blank',
                },
              ]}
            >
              <InputNumber
                className="number-input"
                min={1}
                formatter={value => Number(value).toLocaleString('en-US')}
                parser={value => Number(value.toString().split(',').join(''))}
              />
            </Form.Item>
            <Form.Item
              label={'Trade Window'}
              name={'tradeWindow'}
              rules={[
                {
                  required: true,
                  message: 'Please select the date',
                },
              ]}
            >
              <DatePicker className="date-picker" />
            </Form.Item>
            <Form.Item
              label={'Settlement Date'}
              name={'settlementWindow'}
              rules={[
                {
                  required: true,
                  message: 'Please select the date',
                },
              ]}
            >
              <DatePicker className="date-picker" />
            </Form.Item>
            {/* <Form.Item
              label={'Right Allotment Date'}
              name={'rightAllotmentDate'}
              rules={[
                {
                  message: 'Please select the date',
                },
              ]}
            >
              <DatePicker className="date-picker" />
            </Form.Item>
            <Form.Item
              label={'Effective Date'}
              name={'effectiveDate'}
              rules={[
                {
                  message: 'Please select the date',
                },
              ]}
            >
              <DatePicker className="date-picker" />
            </Form.Item> */}
          </Col>
        </Row>

        <Form.Item>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            key={'submit'}
            style={{ float: 'right' }}
            loading={loading}
          >
            Split Share
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default ShareSplitting;
